const phonePrefixesSalesforce = [
  {
    value: '+33 (France)',
    label: '+33'
  },
  {
    value: '+34 (Spain)',
    label: '+34'
  },
  {
    value: '+39 (Italy)',
    label: '+39'
  },
  {
    value: '+49 (Germany)',
    label: '+49'
  },
  {
    value: '+30 (Greece)',
    label: '+30'
  },
  {
    value: '+31 (Netherlands)',
    label: '+31'
  },
  {
    value: '+32 (Belgium)',
    label: '+32'
  },
  {
    value: '+36 (Hungary)',
    label: '+36'
  },
  {
    value: '+41 (Switzerland)',
    label: '+41'
  },
  {
    value: '+43 (Austria)',
    label: '+43'
  },
  {
    value: '+44 (UK)',
    label: '+44'
  },
  {
    value: '+45 (Denmark)',
    label: '+45'
  },
  {
    value: '+46 (Sweden)',
    label: '+46'
  },
  {
    value: '+47 (Norway)',
    label: '+47'
  },
  {
    value: '+48 (Poland)',
    label: '+48'
  },
  {
    value: '+351 (Portugal)',
    label: '+351'
  },
  {
    value: '+352 (Luxembourg)',
    label: '+352'
  },
  {
    value: '+420 (Czech Republic)',
    label: '+420'
  },
  {
    value: '+421 (Slovakia)',
    label: '+421'
  }
];

export default phonePrefixesSalesforce;
